import { useQuery } from "@tanstack/react-query";
import axios from "../axios-orders";
import { PurchaseOrderResponse } from "../types";
import { queryKeys } from "./queryKeys";

const fetchOc = async (id: string): Promise<PurchaseOrderResponse> => {
  const { data } = await axios.get(`/purchase-orders/${id}`);
  return data;
};

/** True when the error is the backend's 404 (foreign / missing / deleted OC). */
export const isOcNotFound = (error: unknown): boolean =>
  (error as { response?: { status?: number } } | null)?.response?.status ===
  404;

/** One purchase order in full. Disabled without an id; a 404 is final (never retried). */
export const useOc = (id: string | undefined) =>
  useQuery<PurchaseOrderResponse, Error>({
    queryKey: [queryKeys.PURCHASE_ORDER, id],
    queryFn: () => fetchOc(id as string),
    enabled: Boolean(id),
    retry: (failureCount, error) => !isOcNotFound(error) && failureCount < 2,
  });
